const RepeatedRepairCrosses = [
  [5.0, 4],
  [58.0, 5],
  [8.0, 30],
  [18.0, 31],
  [22.0, 31],
  [83.0, 32],
  [34.0, 36],
  [70.0, 39],
  [2.0, 44],
  [4.0, 44],
  [51.0, 44],
  [37.0, 63],
  [21.0, 71],
  [31.0, 72],
];

export default RepeatedRepairCrosses;
